<template>
<div class="contact">
  <p>
    <span>数据说明</span><br />
    1. 投融资数据覆盖医疗健康领域。<br />
    2. 本页面涉及的融资事件仅包括从天使轮到IPO以前的风险投资事件，不包括并购事件或二级市场融资。<br />
    3. 本页面将天使轮、种子轮、种子VC等合并为天使轮；所有带A的轮次合并为A轮；所有带B的轮次合并为B轮；<br />&nbsp;&nbsp;&nbsp;&nbsp;所有带C的轮次合并为C轮；D轮及以后IPO以下的轮次合并为D轮及以上；“其他”包括战略融资、股权转让、债券融资、捐赠/众筹等。<br />
    4. 本页面数据将融资额为数百万/千万/亿统一划定为1百万/千万/亿。<br />
    <template v-if="page == 3">
    5. 原始数据采集自公开渠道，可能存在遗漏或错误信息，但我们着力确保更高的可靠性。<br />
    6. 如需对数据纠错或进行其他数据反馈，欢迎随时联系我们，客服咨询:17338335471。
    </template>
    <template v-else>
    5. 本页面金额计量统一换算成美元（根据事件发生当年的平均汇率换算）。<br />
    6. 原始数据采集自公开渠道，可能存在遗漏或错误信息，但我们着力确保更高的可靠性。<br />
    7. 如需对数据纠错或进行其他数据反馈，欢迎随时联系我们，客服咨询:17338335471。<br />
    8. 在当前热点领域统计功能中：若公司业务涉及多个细分领域，其获得融资时，则该页面多个细分领域会同时计数（事件数、融资额）。
    </template>
  </p>
  <div>
    <img :src="$store.state.static_img_url+'pic/vip_layer/ewm.png'" />
    <p class="scan">在线客服</p>
  </div>
</div>
</template>

<script>
export default {
  props: ['page']
}
</script>

<style lang="stylus" scoped>
.contact
  font-size: 0
  padding-top: 30px
  display: flex
  justify-content: space-between
  img
    width: 80px
    height: 80px
  div
    p
      line-height: 16px
  p
    font-size: 12px
    commonColor(#BCBDC1, #666666)
    line-height:20px
    span
      commonColor(#E9E9EB, #333333)
      font-weight: bold
    &.scan
      margin-top: 8px
      text-align: center
</style>
